export function findObjectInArray(objArray, searchKey, searchValue, getIndexOnly = false) {
    if (getIndexOnly) {
        return objArray.findIndex(obj => obj[searchKey] === searchValue);
    }

    return objArray.find(obj => obj[searchKey] === searchValue);
}

export function updateOrAddObjectValueInArray(objArray, searchKey, searchValue, updateKey, updateValue) {
    const newArr = [...objArray];
    const index = findObjectInArray(newArr, searchKey, searchValue, true);
    if (index >= 0) {
        newArr[index][updateKey] = updateValue;
    } else {
        const newObj = {};
        newObj[searchKey] = searchValue;
        newObj[updateKey] = updateValue;
        newArr.push(newObj);
    }

    return newArr;
}
